import {
  faFileLines,
  faHouse,
  faPersonDigging,
  faSeedling,
  faTrowelBricks,
} from "@fortawesome/free-solid-svg-icons";
import { NavAsideInfo } from "../components/NavAside";
import { fa } from "./sections/util";

export const sectionInfo: NavAsideInfo[] = [
  ["base", "Basisgegevens", "Gegevens", fa(faFileLines)],
  // ["condition", "Bodemchemie", "Chemie", LabsIcon],
  ["build", "Ontwikkeling", "Ontwikkeling", fa(faTrowelBricks)],
  ["surroundings", "Omgeving", "Omgeving", fa(faHouse)],
  ["soil", "Bodem", "Bodem", fa(faPersonDigging)],
  // ["objects", "Bodemvreemde objecten", ShovelWarningIcon],
  // ["alien", "Bodemvreemde objecten", "Bodemvreemd", ShovelWarningIcon],
  ["flora", "Flora & Fauna", "Natuur", fa(faSeedling)],
];
export const sections = Object.fromEntries(
  sectionInfo.map(([name, title, short, Icon, options]) => [
    name,
    { name, title, short, Icon, options },
  ])
);
